var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.08,21a8.9,8.9,0,0,1-3.53-.71,9.41,9.41,0,0,1-2.89-1.94,9.23,9.23,0,0,1-1.95-2.87A8.94,8.94,0,0,1,3,12a8.69,8.69,0,0,1,.71-3.5,9.21,9.21,0,0,1,2-2.84A9.33,9.33,0,0,1,8.55,3.7,8.9,8.9,0,0,1,12.08,3a8.52,8.52,0,0,1,3.78.87A9.76,9.76,0,0,1,19,6.27V3.63h1.5V8.82H15.22V7.32h2.63a8.7,8.7,0,0,0-2.59-2,6.74,6.74,0,0,0-3.18-.78A7.45,7.45,0,0,0,6.72,6.64,7,7,0,0,0,4.5,11.88a7.4,7.4,0,0,0,2.2,5.4,7.29,7.29,0,0,0,5.38,2.22,7.07,7.07,0,0,0,5.27-2.2A7.36,7.36,0,0,0,19.5,12H21a8.77,8.77,0,0,1-2.6,6.39A8.53,8.53,0,0,1,12.08,21Zm3-4.92-3.84-3.81V6.93h1.5v4.72L16.2,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdate);
export default __webpack_public_path__ + "static/media/icon-update.040230f7fe4ddd31ccde17b87e757873.svg";
export { ForwardRef as ReactComponent };